import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { superAdminGet } from './api';

export interface SuperAdminEventsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminEventsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'startTime DESC'
};

function buildFilter(filter: SuperAdminEventsFilter = DEFAULT_FILTER): SuperAdminEventsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolEvents(
  schoolId: string,
  filter: SuperAdminEventsFilter = DEFAULT_FILTER
): Promise<any[]> {
  return superAdminGet<any[]>(`/schools/${schoolId}/events`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolEvents(schoolId: string, where?: any): Promise<any[]> {
  return superAdminGet<any[]>(`/schools/${schoolId}/events`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolEventsCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/events/count`, config);
}

export function getSuperAdminSchoolEvent(schoolId: string, eventId: string): Promise<any> {
  return superAdminGet<any>(`/schools/${schoolId}/events/${eventId}`);
}
